import React, { useEffect, useState } from 'react';
import { useDebounce } from 'use-debounce';
import { Center, Text, Box, HStack, VStack, Input, FlatList, useTheme } from 'native-base';
import SearchResultItem from './SearchResultItem';
import GoBackButton from '../content/common/GoBackButton';
import { getFriendlyOrDiscourseUsername } from '../utils/helpers';
import { useAuthState } from '../../context/auth';
import { useEnvState } from '../../context/env';
import { searchAPI } from '../../context/search';
import { LANGUAGES, DEBOUNCE_DELAY, SEARCH_TERM_MIN } from '../Constants';
const SearchRecipient = _ref => {
  let {
    navigation
  } = _ref;
  const theme = useTheme(),
    {
      colors
    } = theme;
  const envState = useEnvState();
  const [term, setTerm] = useState('');
  const [usersResult, setUsersResult] = useState([]);
  const [debouncedValue] = useDebounce(term, DEBOUNCE_DELAY);
  const isInputValid = debouncedValue.length >= SEARCH_TERM_MIN;
  const authState = useAuthState();
  const authUserName = `${envState.discourse_api_username_prefix}.${authState.platform_user_id}`;
  useEffect(() => {
    if (isInputValid) {
      handleSearchResult();
    }
  }, [debouncedValue]);
  const renderItem = _ref2 => {
    let {
      item: user
    } = _ref2;
    if (user.username !== authUserName) {
      return /*#__PURE__*/React.createElement(SearchResultItem, {
        user: user,
        key: getFriendlyOrDiscourseUsername(user, 'friendly') + getFriendlyOrDiscourseUsername(user, 'discourse'),
        navigation: navigation
      });
    }
  };
  const handleSearchResult = async () => {
    try {
      let data = [];
      const response = await searchAPI.searchUser(envState.base_url, authState.api_key, debouncedValue, envState.product);
      if (response && response.users) {
        data = response.users;

        // remove self from list
        data = data.filter(user => user.username !== authUserName);

        // remove moderators from list
        data = data.filter(user => !user.moderator);
      }
      setUsersResult(data);
      return data;
    } catch (err) {
      console.log('Error while searching for recipients');
      return [];
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GoBackButton, {
    navigation: navigation
  }), /*#__PURE__*/React.createElement(Text, {
    alignSelf: 'center',
    fontSize: 'md',
    fontWeight: 'bold'
  }, "Search User"), /*#__PURE__*/React.createElement(Box, {
    w: '100%',
    h: '100%',
    mt: 4
  }, /*#__PURE__*/React.createElement(VStack, {
    space: 2
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(HStack, {
    space: 4,
    justifyContent: 'center',
    alignItems: 'center'
  }, /*#__PURE__*/React.createElement(Box, {
    px: 2,
    w: '80%',
    h: 10,
    borderWidth: 1,
    borderRadius: 20,
    borderColor: colors.searchRecipient.box.border,
    justifyContent: 'center'
  }, /*#__PURE__*/React.createElement(Input, {
    placeholder: LANGUAGES.PLACEHOLDERS.SEARCH_USERS,
    borderRadius: 20,
    borderColor: colors.searchRecipient.input.border,
    value: term,
    onChangeText: text => setTerm(text),
    autoCapitalize: 'none',
    _focus: {
      borderColor: colors.searchRecipient.input.border,
      borderWidth: 0,
      borderStyle: 'none',
      bg: colors.searchRecipient.input.bg,
      outlineStyle: 'none',
      outlineColor: colors.searchRecipient.input.outline
    }
  })))), debouncedValue.length > 0 && !isInputValid && /*#__PURE__*/React.createElement(Box, {
    justifyContent: 'center',
    alignItems: 'center'
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: 'xs',
    color: colors.searchRecipient.message,
    my: 0
  }, "Please enter at least 3 characters")), /*#__PURE__*/React.createElement(Box, {
    borderBottomWidth: 1,
    borderBottomColor: colors.searchRecipient.divider,
    h: 1
  }), usersResult && usersResult.length > 0 ? /*#__PURE__*/React.createElement(Box, {
    h: 96
  }, /*#__PURE__*/React.createElement(FlatList, {
    data: usersResult,
    renderItem: renderItem,
    keyExtractor: user => getFriendlyOrDiscourseUsername(user, 'friendly') + getFriendlyOrDiscourseUsername(user, 'discourse')
  })) : /*#__PURE__*/React.createElement(Center, null, /*#__PURE__*/React.createElement(Text, null, "No user(s) found")))));
};
export default SearchRecipient;
//# sourceMappingURL=SearchRecipient.js.map